const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  },
  topGrid: {
    marginTop: theme.spacing.unit * 2,
    textAlign: "center",
    paddingLeft: "5%"
  },
  leftGrid: {
    borderRight: "0.5px solid #D3D3D3",
    textAlign: "center",
    height: "115px"
  },
  rightGrid: {
    //borderRight: "0.5px solid #D3D3D3",
    textAlign: "center",
    height: "115px"
  },
  t_tar_text: {
    fontSize: "12pt",
    marginTop: theme.spacing.unit * 3
  },
  t_tar_no: {
    fontSize: "30pt",
    fontWeight: "bold"
  },
  t_tar_text_p: {
    fontSize: "12pt",
    color: `${theme.palette.success} !important`,
    marginTop: theme.spacing.unit * 4
  },
  t_tar_no_p: {
    fontSize: "15pt",
    color: `${theme.palette.success} !important`,
    fontWeight: "bold"
  },
  t_tar_text_f: {
    fontSize: "12pt",
    color: `${theme.palette.fail} !important`,
    marginTop: theme.spacing.unit * 4
  },
  t_tar_no_f: {
    fontSize: "15pt",
    color: `${theme.palette.fail} !important`,
    fontWeight: "bold"
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/results/thumbnails/views/maxthroughputtest/styles.js